import { render, staticRenderFns } from "./ProductItemPage.vue?vue&type=template&id=118fa8c4"
import script from "./ProductItemPage.vue?vue&type=script&lang=js"
export * from "./ProductItemPage.vue?vue&type=script&lang=js"
import style0 from "./ProductItemPage.vue?vue&type=style&index=0&id=118fa8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports